import React from 'react';

const LoadingDetails = () => {
  return (
    <div role="status" className="animate-pulse p-5">
      <div className="h-8 w-56 bg-gray-200 mb-4" />
      <hr className="my-4" />
      <div className="h-6 w-56 bg-gray-200 mb-4" />
      <div className="h-4 bg-gray-200 mb-2.5" />
      <div className="h-4 bg-gray-200 mb-2.5" />
      <hr className="my-5" />
      <div className="h-6 w-56 bg-gray-200 mb-4" />
      <div className="h-4 bg-gray-200 mb-2.5" />
      <div className="h-4 bg-gray-200" />
    </div>
  );
};

export default LoadingDetails;
